import { useState, useEffect } from "react";
import { Smile } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { STICKERS } from "../lib/constants";
import api from "../lib/api";

export default function StickerPicker({ onPick }) {
  const [open, setOpen] = useState(false);
  const [extra, setExtra] = useState([]);

  useEffect(() => {
    if (open) api.get("/shop/inventory").then((r) => setExtra(r.data.pack_stickers || [])).catch(() => {});
  }, [open]);

  const all = [...STICKERS, ...extra];
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="sticker-picker-btn" className="p-2 rounded-full hover:bg-secondary text-copper">
          <Smile className="w-5 h-5" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 rounded-2xl">
        {extra.length > 0 && <p className="text-[10px] font-mono uppercase tracking-widest text-copper mb-1.5">Your packs unlocked more 💛</p>}
        <div className="grid grid-cols-6 gap-1 max-h-56 overflow-y-auto no-scrollbar">
          {all.map((s, i) => (
            <button key={`${s}-${i}`} type="button" onClick={() => { onPick(s); setOpen(false); }}
              className="text-2xl p-1.5 rounded-lg hover:bg-secondary transition-colors">{s}</button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}

